// src/components/ResetPassword.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom'; 
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../../firebaseConfig';
import { FiArrowLeft, FiMail } from 'react-icons/fi';


// Logo Component

function ResetPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState(''); 
  const [isError, setIsError] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setMessage('');
    setIsError(false);

    if (!email) {
      setMessage('Please enter your email address.');
      setIsError(true);
      return;
    }

    setLoading(true);
    try {
      await sendPasswordResetEmail(auth, email);
      setMessage('If an account exists for this email, a password reset link has been sent. Please check your inbox (and spam folder).');
      setIsError(false); 
      setEmail(''); 
    } catch (err) {
      setMessage('If an account exists for this email, a password reset link has been sent. Please check your inbox (and spam folder).');
      setIsError(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center py-20 px-4 sm:px-6 lg:px-8 min-h-[80vh]">
        <div className="max-w-md w-full space-y-8 bg-warm-gray/10 backdrop-blur-xl rounded-[2.5rem] p-10 border border-white/5 shadow-2xl hover:border-white/10 transition-all duration-500">
          <div className="text-center">
            <h2 className="text-2xl font-black text-white tracking-tight mb-2">
              Reset Password
            </h2>
            <p className="mt-2 text-sm text-cream/60">
              Enter your email, and we’ll send you a link to reset your password.
            </p>
          </div>

          <form className="mt-8 space-y-6" onSubmit={handleResetPassword}>
            <div className="space-y-4">
                <div className="relative group">
                    <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                        <FiMail className="h-5 w-5 text-slate-blue group-focus-within:text-white transition-colors" />
                    </div>
                     <label htmlFor="email-address" className="sr-only">Email address</label>
                    <input
                        id="email-address" name="email" type="email" autoComplete="email" required
                        className="block w-full pl-12 pr-4 py-4 bg-black/20 border border-white/5 rounded-2xl text-cream placeholder-white/20 focus:outline-none focus:ring-2 focus:ring-slate-blue/50 focus:border-transparent transition-all"
                        placeholder="Email Address" value={email} onChange={(e) => setEmail(e.target.value)} disabled={loading}
                    />
                </div>
            </div>

            {/* Message Display */}
            {message && (
              <div className={`p-4 rounded-xl text-sm text-center font-medium border animate-fade-in ${isError ? 'bg-red-500/10 border-red-500/20 text-red-200' : 'bg-green-500/10 border-green-500/20 text-green-200'}`}>
                {message}
              </div>
            )}

            <button
                type="submit" disabled={loading}
                className="group relative w-full flex justify-center py-4 px-4 border border-transparent text-sm font-bold uppercase tracking-wider rounded-2xl text-warm-dark bg-slate-blue hover:bg-slate-blue/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-slate-blue shadow-glow transition-all hover:scale-[1.02] active:scale-[0.98] disabled:opacity-70 disabled:cursor-not-allowed"
            >
                {loading ? (
                    <span className="flex items-center gap-2">
                         <svg className="animate-spin -ml-1 h-5 w-5 text-warm-dark" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        Sending...
                    </span>
                ) : 'Send Reset Link'}
            </button>
          </form>

          {/* Login Link */}
          <div className="text-center pt-6 border-t border-white/5 mt-6">
            <Link to="/login" className="inline-flex items-center gap-2 font-bold text-slate-blue hover:text-white transition-colors uppercase tracking-wide text-xs group">
                <FiArrowLeft className="group-hover:-translate-x-1 transition-transform" />
                Back to Login
            </Link>
          </div>
        </div>
    </div>
  );
}

export default ResetPassword;
